import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Lists
export const GET_CAMPAIGN_LIST = 'GET_CAMPAIGN_LIST';
export const GET_CAMPAIGN_LIST_SUCCESS = 'GET_CAMPAIGN_LIST_SUCCESS';
export const GET_CAMPAIGN_LIST_FAILURE = 'GET_CAMPAIGN_LIST_FAILURE';

// Action Creators
export const fetchGetCampaignList = () => ({
  type: GET_CAMPAIGN_LIST,
});

export const fetchGetCampaignListSuccess = (data) => ({
  type: GET_CAMPAIGN_LIST_SUCCESS,
  payload: data,
});

export const fetchGetCampaignListFailure = (error) => ({
  type: GET_CAMPAIGN_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getCampaignListCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetCampaignList(data, external));
    try {
      const response = await getMethodWithToken(url.getCampaignListSuperAdmin);
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetCampaignListSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetCampaignListFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetCampaignListFailure(error.message));
    }
  };
};
